import { HTMLAttributes } from 'react'

import RibbonPictures from '@/components/sections/RibbonPictures'

import { cn } from '@/lib/utils'
import { WPImage, WPPageData } from '@/types'

export type DoubleRibbonPicturesProps = HTMLAttributes<HTMLElement> &
  Partial<{
    items: WPImage[]
    items_foreground: WPImage[]
    theme: WPPageData['acf']['theme']
  }>

const DoubleRibbonPictures = ({
  items,
  items_foreground,
  theme,
  className,
  ...props
}: DoubleRibbonPicturesProps) => {
  return (
    <section
      {...props}
      className={cn([
        {
          'bg-dark-100': theme === 'light',
          'bg-dark-600': theme === 'dark'
        },
        className
      ])}
    >
      <RibbonPictures items={items} />
      <RibbonPictures items={items_foreground} className="-mt-[5rem]" />
    </section>
  )
}

export default DoubleRibbonPictures
